<div class="overlay-wrapper" id="overlay">
    <!-- Show the overlay when isOpenOverlay is true -->
    <ng-react *ngIf="isOpen" [component]="overlay" [props]="overlayProps"></ng-react>

    <div class="overlay-content">
        <ng-content></ng-content>
    </div>
</div>
